// extracted by mini-css-extract-plugin
export default {"root":"LazyLoadingCards_root__CCW+L"};